var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgUser = function SvgUser(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5073 3.40016L7.54727 1.1135C6.9006 0.740163 6.1006 0.740163 5.44727 1.1135L1.49393 3.40016C0.847265 3.7735 0.447266 4.46683 0.447266 5.22016V9.78016C0.447266 10.5268 0.847265 11.2202 1.49393 11.6002L5.45393 13.8868C6.1006 14.2602 6.9006 14.2602 7.55393 13.8868L11.5139 11.6002C12.1606 11.2268 12.5606 10.5335 12.5606 9.78016V5.22016C12.5539 4.46683 12.1539 3.78016 11.5073 3.40016ZM6.5006 4.3935C7.3606 4.3935 8.05393 5.08683 8.05393 5.94683C8.05393 6.80683 7.3606 7.50016 6.5006 7.50016C5.6406 7.50016 4.94727 6.80683 4.94727 5.94683C4.94727 5.0935 5.6406 4.3935 6.5006 4.3935ZM8.28727 10.6068H4.71393C4.17393 10.6068 3.8606 10.0068 4.1606 9.56016C4.61393 8.88683 5.49393 8.4335 6.5006 8.4335C7.50727 8.4335 8.38727 8.88683 8.8406 9.56016C9.1406 10.0002 8.8206 10.6068 8.28727 10.6068Z",
    fill: "#868992"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUser, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/user.b4ef0e06.svg";
export { ForwardRef as ReactComponent };